export const preloadScriptWithWorker = (scriptUrl, onLoadCallback, onErrorCallback) => {
    if (typeof window !== "undefined" && window.Blob && window.URL) {
        const workerCode = `
        self.onmessage = async (event) => {
            if (event.data.action === 'preloadScript') {
                try {
                    const response = await fetch(event.data.url);
                    const scriptContent = await response.text();
                    self.postMessage({ status: 'success', scriptContent });
                } catch (error) {
                    self.postMessage({ status: 'error', error: error.message });
                }
            }
        };
    `;

        let blob = "";
        // Create a Blob from the worker code and initialize the worker
        blob = new window.Blob([workerCode], { type: "application/javascript" });
        const worker = new window.Worker(window.URL.createObjectURL(blob));

        worker.postMessage({ action: "preloadScript", url: scriptUrl });

        worker.onmessage = (event) => {
            if (event.data.status === "success") {
                if (onLoadCallback) onLoadCallback(event.data.scriptContent);
            } else if (event.data.status === "error") {
                // console.error("Error preloading script:", event.data.error);
                if (onErrorCallback) onErrorCallback(event.data.error); // Trigger the error callback
            }

            worker.terminate(); // Clean up the worker
        };
    } else {
        const error = new Error("Window is not defined. This function can only be run in a browser environment.");
        onErrorCallback(error.message);
    }
};
